import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path d=\"M2.5 6.5H21.5\" stroke=\"currentColor\" stroke-linecap=\"square\" stroke-linejoin=\"round\"></path><path d=\"M2.5 11.5H21.5\" stroke=\"currentColor\" stroke-linecap=\"square\" stroke-linejoin=\"round\"></path><path d=\"M2.5 16.5H21.5\" stroke=\"currentColor\" stroke-linecap=\"square\" stroke-linejoin=\"round\"></path><path d=\"M6.5 2V21.5\" stroke=\"currentColor\" stroke-linecap=\"square\" stroke-linejoin=\"round\"></path><path d=\"M11.5 2.5V21.5\" stroke=\"currentColor\" stroke-linecap=\"square\" stroke-linejoin=\"round\"></path><path d=\"M16.5 2.5V21.5\" stroke=\"currentColor\" stroke-linecap=\"square\" stroke-linejoin=\"round\"></path><rect x=\"1.5\" y=\"1.5\" width=\"21\" height=\"21\" rx=\"1.5\" stroke=\"currentColor\"></rect>", 7)
const _hoisted_9 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_9))
}
export default { render: render }